export default [
    {
        path: '/vistoria', component: () => import('./components/Page'), name: 'vistoria.page', children: [
            {path: '', component: () => import('./components/Vistorias'), name: 'vistorias'},
            {path: ':id', component: () => import('./components/Vistoria'), name: 'vistoria.show'},
            {path: 'registro', component: () => import('./components/Vistoria'), name: 'vistoria.new'},
        ]
    }
]
